import { IActionType } from '../../../types/action';

export const RESET_DETAIL_INVESTOR = 'RESET_DETAIL_INVESTOR';

export const resetDetailInvestorAC = (): IActionType => ({ type: RESET_DETAIL_INVESTOR });
